import { App, defineAsyncComponent } from 'vue'

const AuthProvider = defineAsyncComponent(
  () => import('@m/auth/components/AuthProvider.vue')
)
const LoginForm = defineAsyncComponent(
  () => import('@/modules/auth/components/LoginForm.vue')
)
const SetPasswordForm = defineAsyncComponent(
  () => import('@/modules/auth/components/SetPasswordForm.vue')
)
const ReSetPasswordForm = defineAsyncComponent(
  () => import('@/modules/auth/components/ReSetPasswordForm.vue')
)

export default {
  install(app: App<Element>): void {
    app
      .component('AuthProvider', AuthProvider)
      .component('LoginForm', LoginForm)
      .component('SetPasswordForm', SetPasswordForm)
      .component('ReSetPasswordForm', ReSetPasswordForm)
  }
}